import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: 10,
    height: 100,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    color: '#c4302b',
  },
  divider: {
    height: 28,
    margin: 4,
  },
  bottomCard: {
    margin: 10,
    borderRadius: 5,
    padding: 10,
    marginBottom: 10,
    border: '1px solid #ccc',
    // background: 'red',
    // backgroundColor: 'red',
    width: '70%',
    maxWidth: '400px',
    height: 300,
    cursor: 'pointer',
    boxSizing: 'border-box',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#999',
    },
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconCard: {
    fontSize: '40px'
  },
  disabled: {
    opacity: 0.1,
    pointerEvents: 'none',
    margin: 10,
    borderRadius: 5,
    padding: 10,
    marginBottom: 10,
    border: '1px solid #ccc',
    backgroundColor: 'grey',
    width: '60%',
    maxWidth: '400px',
    color: 'black',
    height: 300,
    cursor: 'pointer',
    boxSizing: 'border-box',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#999',
    },
  },
}))

export default useStyles
